/**
 * Readable column list for `public.users`.
 *
 * Table-level SELECT was revoked from `anon`/`authenticated` and re-granted
 * column-by-column, deliberately excluding `wp_password_hash`,
 * `google_oauth_id` and `linkedin_oauth_id`. Postgres denies the whole
 * statement when a query touches a column the role cannot read, so `select=*`
 * against `public.users` always returns 403.
 *
 * Use this constant for every profile read and for the returning clause of
 * every profile write. Never use `'*'` on `users`.
 */
export const USERS_SELECT_COLUMNS = [
  'about',
  'about_en',
  'about_en_hash',
  'about_source_language',
  'address_1',
  'address_2',
  'address_3',
  'business',
  'calendar',
  'city',
  'coordinates',
  'country',
  'created_at',
  'currency_preference',
  'date_format_preference',
  'display_name',
  'email',
  'email_verified_at',
  'facebook',
  'firm_type',
  'first_day_of_week',
  'global_rank',
  'id',
  'image',
  'image_type',
  'instagram',
  'last_login_at',
  'lastname',
  'legacy_id',
  'linkedin',
  'linkedin_urn',
  'locale',
  'location_id',
  'marker_image',
  'membership_tier',
  'name',
  'number_format_preference',
  'parent_user_id',
  'postal_zip_code',
  'profile_active',
  'profile_listed',
  'profile_map_image',
  'profile_verified',
  'state_province',
  'telephone',
  'timezone',
  'title',
  'type',
  'updated_at',
  'vanity_url',
  'website',
  'wp_avatar_hash',
  'wp_imported_at',
  'wp_last_synced_at',
  'wp_source_site',
  'wp_staging_hash',
  'wp_user_id',
  'X_status',
  'years_experience',
].join(', ');
